import { useDispatch, useSelector } from 'react-redux';
import { AddClassroomContainer } from 'containers';
import Classroom from 'models/Classroom';
import * as React from 'react';
import { RootState } from 'reducers';
import { useHistory } from 'react-router-dom';
import { UpdateClassroom as updateClassroomAction } from 'actions';

const UpdateClassroom: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { selectedclassroom } = useSelector(
    (state: RootState) => state.Classroom,
  );
  const handleUpdate = async (data: Classroom): Promise<void> => {
    await dispatch(updateClassroomAction(data.id, data));
    history.goBack();
  };

  return (
    <>
      <div className="bg-primary">
        <div className="container space-1 space-top-lg-2 space-bottom-lg-3">
          <div className="row align-items-center">
            <div className="col">
              <div className="d-none d-lg-block">
                <h1 className="h1 text-white">Salles</h1>
              </div>
              <ol className="breadcrumb breadcrumb-light breadcrumb-no-gutter mb-0">
                <li className="breadcrumb-item text-white">
                  Modifier une salle
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="container space-1 space-top-lg-0 mt-lg-n10">
        <div className="card">
          <div className="card-body">
            <AddClassroomContainer
              initialValues={selectedclassroom}
              onSubmit={handleUpdate}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateClassroom;
